<template>
  <div class="mt-6" data-testid="kss-create-form">
    <IftaLabel class="mb-3 w-full">
      <InputText maxlength="100" id="txt_subject" v-model="subjectComputed"
        data-testid="kss-create-subject"
        class="w-full h-12"/>
      <label for="txt_subject"> {{ $t("KssFormComponent.addMeetingSubject") }}</label>
    </IftaLabel>
    <IftaLabel class="mb-3 w-full">
      <InputText id="txt_description" v-model="descriptionComputed"
        data-testid="kss-create-description"
        class="w-full h-12"/>
      <label for="txt_description"> {{ $t("KssFormComponent.addDescription") }}</label>
    </IftaLabel>
    <!----------------- ADD TEAMS ----------------->
    <MultiSelect v-model="selectedTeams" display="chip" :options="teams"
      optionLabel="name" filter :placeholder="$t('KssFormComponent.addTeams')"
      data-testid="kss-create-teams-multiselect"
      class="w-full mt-1" @update:modelValue="handleTeamSelectionChange">
      <template #chip="{ value, removeCallback }">
        <div class="p-multiselect-token bg-[#f1f5f9] px-2 py-1 rounded flex items-center gap-1">
          <span>{{ value.name }}</span>
          <span class="cursor-pointer" @click="removeCallback">
            <i class="pi pi-trash"></i>
          </span>
        </div>
      </template>
    </MultiSelect>
    <!----------------- ADD PARTICIPANTS ----------------->
    <MultiSelect v-model="selectedParticipants" display="chip" :options="participants"
      optionLabel="name" filter :placeholder="$t('KssFormComponent.addParticipants')"
      data-testid="kss-create-participants-multiselect"
      class="w-full mt-1" @update:modelValue="handleSelectionChange">
      <template #chip="{ value, removeCallback }">
        <div class="p-multiselect-token bg-[#f1f5f9] px-2 py-1 rounded flex items-center gap-1"
             data-testid="kss-create-participant-chip">
          <span>{{ value.name }}</span>
          <span class="cursor-pointer" data-testid="kss-create-participant-chip-remove" @click="removeCallback">
            <i class="pi pi-trash"></i>
          </span>
        </div>
      </template>
    </MultiSelect>
    <external-users-invite-component class="relative mt-3 w-full"/>
  </div>
</template>

<script>
import ExternalUsersInviteComponent
  from '@/components/Home/KssCreator/ExternalUsersInviteComponent.vue';
import {
  IftaLabel,
  InputText,
  MultiSelect,
} from 'primevue';

export default {
  name: 'KssFormComponent',
  components: {
    ExternalUsersInviteComponent,
    IftaLabel,
    InputText,
    MultiSelect,
  },
  data() {
    return {
      showTeams: false,
      showParticipants: false,
      showEmailInvite: false,
      participants: this.$store.getters.getKssParticipants,
    };
  },
  computed: {
    /** Excludes admin/internal teams; indices in handlers use full getTeams for store mutation. */
    teams() {
      return this.$store.getters.getTeamsForSelection;
    },
    subjectComputed: {
      get() {
        return this.$store.state.kss.newMeetingSubject;
      },
      set(val) {
        this.$store.commit('setNewSubject', val);
      },
    },
    selectedParticipants() {
      return this.$store.getters.getKssParticipants.filter((el) => el.isChecked);
    },
    selectedTeams() {
      return this.$store.getters.getTeams.filter((el) => el.isChecked);
    },
    externalEmails() {
      return this.$store.getters.getInviteEmails;
    },
    descriptionComputed: {
      get() {
        return this.$store.state.kss.newDescription;
      },
      set(val) {
        this.$store.commit('setNewDescription', val);
      },
    },
  },
  methods: {
    handleTeamSelectionChange(newSelected) {
      // const all = this.participants;
      this.teams.forEach((p) => {
        const shouldBeChecked = newSelected.some((sel) => sel._id === p._id);
        if (p.isChecked !== shouldBeChecked) {
          const index = this.$store.getters.getTeams
            .findIndex((item) => item._id === p._id);
          this.$store.commit('updateKssTeamSelection', index);
        }
      });
    },
    handleSelectionChange(newSelected) {
      // const all = this.participants;
      this.participants.forEach((p) => {
        const shouldBeChecked = newSelected.some((sel) => sel._id === p._id);
        if (p.isChecked !== shouldBeChecked) {
          const index = this.$store.getters.getKssParticipants
            .findIndex((item) => item._id === p._id);
          this.$store.commit('updateKssParticipantSelection', index);
        }
      });
    },
    debounce(func, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    toggleTeams() {
      this.showTeams = !this.showTeams;
    },
    toggleParticipants() {
      this.showParticipants = !this.showParticipants;
    },
    toggleEmailInvite() {
      this.showEmailInvite = !this.showEmailInvite;
    },
    adjustEmailContainerHeight() {
      const emailContainer = this.$refs['email-container'];
      const resize = () => {
        if (emailContainer.clientHeight >= 60) {
          emailContainer.style.flexDirection = 'column';
          emailContainer.style.alignItems = 'flex-start';
        } else {
          emailContainer.style.flexDirection = 'row';
          emailContainer.style.alignItems = 'center';
        }
      };
      resize();
      const resizeHandler = this.debounce(() => resize(), 100);
      const resizeObserver = new ResizeObserver(resizeHandler);
      resizeObserver.observe(emailContainer);
    },
  },
  mounted() {
    // this.adjustEmailContainerHeight();
  },
};
</script>
